import React from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { SortButtons } from '../../../../shared/components/buttons';
import { challengesListStore } from '../../../stores/challengesListStore';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

const TitleRow = observer(() => {
  const { isSuperAdmin, isEntity, isCoach } = loggedInUserDataStore;

  const { filterMethods } = challengesListStore;
  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="header">
      <GridTableCell>
        <SortButtons
          fieldName="challengeName"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Name
        </SortButtons>
      </GridTableCell>
      {isSuperAdmin && (
        <GridTableCell>
          <SortButtons
            fieldName="entityName"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            Entity
          </SortButtons>
        </GridTableCell>
      )}
      <GridTableCell>
        <SortButtons
          fieldName="customerType"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Type
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons
          fieldName="startDate"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Start Date
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons fieldName="endDate" onSort={handleSort} getIsActive={getIsSortedBy}>
          End Date
        </SortButtons>
      </GridTableCell>
      <GridTableCell>
        <SortButtons
          fieldName="challengeStatus"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Status
        </SortButtons>
      </GridTableCell>
      {(isEntity || isCoach) && (
        <GridTableCell>
          <SortButtons
            fieldName="participantCount"
            onSort={handleSort}
            getIsActive={getIsSortedBy}
          >
            Participants
          </SortButtons>
        </GridTableCell>
      )}
      <div />
    </GridTableRow>
  );
});

export { TitleRow };
